import { render, staticRenderFns } from "./otherexpen.vue?vue&type=template&id=18880635"
import script from "./otherexpen.vue?vue&type=script&lang=js"
export * from "./otherexpen.vue?vue&type=script&lang=js"
import style0 from "./otherexpen.vue?vue&type=style&index=0&id=18880635&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports